import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '../../../lib/utils';
import { SpecraProgress } from '../ensigns/progress';
import { SpecraStatusDot } from '../ensigns/status-dot';
import { SpecraText } from '../ensigns/typography';
/** One subordinate background task with target, progress, and percentage. */ export function SpecraBackgroundJobRow({ className, job, ...props }) {
    return /*#__PURE__*/ _jsxs("div", {
        className: cn('grid items-center gap-3 px-3.5 py-2.5', 'grid-cols-[var(--component-job-state-column)_minmax(0,1fr)_var(--component-job-percent-column)] sm:grid-cols-[var(--component-job-state-column)_minmax(0,1fr)_var(--component-job-target-column)_var(--component-job-percent-column)]', className),
        ...props,
        children: [
            /*#__PURE__*/ _jsx(SpecraStatusDot, {
                size: "sm"
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex min-w-0 items-baseline gap-2",
                children: [
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "truncate font-medium",
                        size: "caption",
                        tone: "secondary",
                        children: job.name
                    }),
                    /*#__PURE__*/ _jsx(SpecraText, {
                        className: "truncate",
                        size: "micro",
                        tone: "muted",
                        children: job.target
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(SpecraProgress, {
                "aria-label": `${job.name} progress`,
                className: "col-span-2 col-start-2 sm:col-span-1 sm:col-start-auto",
                size: "thin",
                tone: "muted",
                value: job.pct
            }),
            /*#__PURE__*/ _jsxs(SpecraText, {
                className: "col-start-3 row-start-1 text-right tabular-nums sm:col-start-auto sm:row-start-auto",
                size: "caption",
                tone: "muted",
                children: [
                    job.pct,
                    "%"
                ]
            })
        ]
    });
}
